import { type MultiselectAccountValue } from "~/features/userAdministration/manageUsers/components/DropdownWithMultiselect/DropdownWithMultiSelect";
import { type MultiSelectAccountData } from "../types";

export const makeAccountDataIntoMultiSelect = ({ list, email }: MultiSelectAccountData): MultiselectAccountValue[] =>
  list
    .filter((item, index, self) => self.findIndex((selfItem) => selfItem.number === item.number) === index) // grab only unique
    .map((item) => ({
      name: item.name + ", " + item.number,
      value: item.id,
      isChecked: email.findIndex((account) => account.id === item.id) > -1,
    }));
